import { useTranslation } from "react-i18next";

export const useFireflySharedTsDomainTranslation = () =>
  useTranslation("firefly-shared-ts-domain");
